export const uk = {
    'add-clients-success': 'todo',
    'change-status-error': 'Ошибка изменения статуса пакета {name}',
    'change-status-success': 'Изменился статус пакета {name}'
};
